import React from "react";
import { Button, Modal, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";
import PrintLabelComponent from "./PrintComponentLabel";

export default class PrintLabel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      order: this.props.order,
    };
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.printLabelModel}
          toggle={(event) => this.props.toggleprintLabelModel(event)}
          className="modal-lg"
        >
          <PrintLabelComponent
            ref={(el) => (this.componentRef = el)}
            order={this.state.order}
          />
          <ModalFooter>
            <Button
              color="secondary"
              onClick={(event) => this.props.toggleprintLabelModel()}
            >
              Close
            </Button>

            <ReactToPrint
              trigger={() => <button>Print this out!</button>}
              content={() => this.componentRef}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
